import React from 'react';
import { useNavigate } from 'react-router-dom';

// Menu items for each hotspot
const menuData = {
  film: [
    { id: 1, label: 'aras (live)', url: 'https://www.youtube.com/watch?v=f6o3icwyAx0' },
    { id: 2, label: 'we never fight', url: 'https://www.youtube.com/watch?v=AnFHmWWFbWY' },
    { id: 3, label: 'dreams on life support', url: 'https://www.youtube.com/watch?v=OJuiEudyo0Q' },
    { id: 4, label: 'music to watch the world burn', url: 'https://www.youtube.com/watch?v=j9qGwiFgAAQ' },
  ],
  music: [
    { id: 1, label: 'depth training', url: 'https://jamblu.bandcamp.com/album/depth-training' },
    { id: 2, label: 'bone ringing', url: 'https://jamblu.bandcamp.com/album/bone-ringing' },
    { id: 3, label: 't.d.f.d.t.u', url: 'https://jamblu.bandcamp.com/album/t-d-f-d-t-u' },
    { id: 4, label: 'gone swimming', url: 'https://jamblu.bandcamp.com/album/gone-swimming' },
    { id: 5, label: 'blue valley golden mountain', url: 'https://jamblu.bandcamp.com/track/blue-valley-golden-mountain' },
    { id: 6, label: 'music to be nothing to', url: 'https://jamblu.bandcamp.com/album/music-to-be-nothing-to' },
    { id: 7, label: 'service animal', url: 'https://jamblu.bandcamp.com/album/service-animal' },
    { id: 8, label: 'how deep is your database', url: 'https://jamblu.bandcamp.com/album/how-deep-is-your-database' },
  ],
  socials: [
    { id: 1, label: 'instagram', url: 'https://www.instagram.com/jambluness/' },
    { id: 2, label: 'youtube', url: 'https://www.youtube.com/@jamblu8447/videos' },
    { id: 3, label: 'bandcamp', url: 'http://jamblu.bandcamp.com' },
    { id: 4, label: 'spotify', url: 'https://open.spotify.com/artist/1B4LXSUI2AxxDVeroz5WI0' },
    { id: 5, label: 'apple music', url: 'https://music.apple.com/in/artist/jamblu/1073178893' },
  ],
  tour: [],
  merch: [],
};

const ConstellationMenu = ({ hotspotLabel, isVisible, onNavigateToPage }) => {
  const navigate = useNavigate();
  const items = menuData[hotspotLabel] || [];
  
  // If no submenu items, don't render the constellation menu
  if (items.length === 0) {
    return null;
  }

  const handleItemClick = (e, item) => {
    e.stopPropagation();
    if (item.url.startsWith('http')) {
      window.open(item.url, '_blank');
    } else {
      navigate(item.url);
    }
  };

  const handleViewAll = (e) => {
    e.stopPropagation();
    onNavigateToPage();
  };

  // Calculate positions for downward spreading branches
  const getItemPosition = (index, total) => {
    // Staggered vertical layout with slight horizontal offset
    const baseY = 50 + (index * 28); // Vertical spacing
    const xOffset = (index % 2 === 0 ? -1 : 1) * (30 + index * 8); // Alternating left/right
    
    return {
      x: xOffset,
      y: baseY,
    };
  };

  return (
    <div className={`constellation-menu ${isVisible ? 'visible' : ''}`}>
      {/* SVG Lines originating from hotspot center */}
      <svg className="constellation-lines" viewBox="-150 -10 300 220">
        {items.map((item, index) => {
          const pos = getItemPosition(index, items.length);
          
          // Control point for organic curve
          const midY = pos.y * 0.5;
          const controlX = pos.x * 0.3;
          
          return (
            <g key={item.id} className="constellation-branch" style={{ animationDelay: `${index * 0.1}s` }}>
              {/* Curved line from center (0,0) to item */}
              <path
                d={`M 0 0 Q ${controlX} ${midY} ${pos.x} ${pos.y}`}
                className="constellation-line"
              />
              {/* Node at the end */}
              <circle
                cx={pos.x}
                cy={pos.y}
                r="2.5"
                className="constellation-node"
              />
            </g>
          );
        })}
        
        {/* Line to "view all" */}
        <g className="constellation-branch" style={{ animationDelay: `${items.length * 0.1}s` }}>
          <path
            d={`M 0 0 L 0 ${50 + items.length * 28 + 20}`}
            className="constellation-line"
          />
          <circle cx="0" cy={50 + items.length * 28 + 20} r="2.5" className="constellation-node" />
        </g>
      </svg>

      {/* Menu items */}
      <div className="constellation-items">
        {items.map((item, index) => {
          const pos = getItemPosition(index, items.length);
          
          return (
            <button
              key={item.id}
              className="constellation-item"
              style={{
                '--item-x': `${pos.x}px`,
                '--item-y': `${pos.y}px`,
                animationDelay: `${index * 0.1 + 0.15}s`
              }}
              onClick={(e) => handleItemClick(e, item)}
              data-testid={`constellation-item-${item.id}`}
            >
              {item.label}
            </button>
          );
        })}
        
        {/* View all link */}
        <button
          className="constellation-item constellation-view-all"
          style={{
            '--item-x': '0px',
            '--item-y': `${50 + items.length * 28 + 20}px`,
            animationDelay: `${items.length * 0.1 + 0.15}s`
          }}
          onClick={handleViewAll}
          data-testid="constellation-view-all"
        >
          view all →
        </button>
      </div>
    </div>
  );
};

export default ConstellationMenu;
